import React from 'react';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import KpiStatRow from '../../../../components/admin/reports/charts/KpiStatRow';

// Resposta é só um punhado de escalares — sem série pra plotar, só KPIs.
export default function FrequencySummaryTiles({dateFrom, dateTo}) {
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_ECOMMERCE_FREQUENCY,
        params: {date_from: dateFrom, date_to: dateTo},
        dataDefault: {},
    });

    return (
        <KpiStatRow
            loading={isLoading}
            items={[
                {title: 'Média de Dias Entre Pedidos', value: data?.avg_days_between_orders ?? 0, precision: 1},
                {title: 'Média de Pedidos por Cliente', value: data?.avg_orders_per_client ?? 0, precision: 1},
                {title: 'Clientes Analisados', value: data?.total_clients_analyzed ?? 0},
                {title: 'Total de Pedidos', value: data?.total_orders ?? 0},
            ]}
        />
    );
}
